module.exports = __webpack_public_path__ + "static/standalone/img/amount-collection.6abe8838.svg";